import "./contentpage.css";
import React, { useState } from "react";
import AvatarPicker from "../components/AvatarPicker";
import ProfileAvatar from "../components/ProfileAvatar";

function BitcoinTech() {
  const [selectedAvatar, setSelectedAvatar] = useState(
    localStorage.getItem("avatar") || ""
  );
  return (
    <div style={{ padding: "20px", fontFamily: "sans-serif" }}>
      <h1>Welcome to Your Learning Dashboard</h1>
      <ProfileAvatar />
      <AvatarPicker onSelect={setSelectedAvatar} />
    </div>
  );
}

export default BitcoinTech;
